/** Ошибка получения доступа к переменной окружения, ожидалось непустое значение */
export class VariableRequiredError extends Error {
    constructor(variableName: string) {
        super(`environment variable "${variableName}" is not defined`);
        this.name = 'VariableRequiredError';
    }
}
